/**
 * 日期筛选
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/4/10      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from "react";
import { Menu, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";

class TimeSelect extends React.Component {
    constructor(props) {
        super(props);
        this.list = [
            { key: 7, label: __getServerLanguage("JinNTian", 7) },
            { key: 30, label: __getServerLanguage("JinNTian", 30) },
            { key: 60, label: __getServerLanguage("JinNTian", 60) },
            { key: 90, label: __getServerLanguage("JinNTian", 90) },
            { key: 180, label: __getServerLanguage("JinNTian", 180) },
        ];
        this.params = {
            name: "",
        };
    }

    handleTime(value) {
        // console.log(`selected ${value}`);
        // let beginDate ='',endDate= dayjs().format('YYYY/MM/DD');
        /*switch (value) {
            case '7':
                beginDate = dayjs().subtract(7, 'days').format('YYYY/MM/DD');
                break;
            case '30':
                beginDate = dayjs().subtract(30, 'days').format('YYYY/MM/DD');
                break;
            case '60':
                beginDate = dayjs().subtract(60, 'days').format('YYYY/MM/DD');
                break;
            case '90':
                beginDate = dayjs().subtract(90, 'days').format('YYYY/MM/DD');
                break;
            case '180':
                beginDate = dayjs().subtract(180, 'days').format('YYYY/MM/DD');
                break;
        }*/

        // this.callBack(beginDate,endDate)
        this.props.callBack(value.key);
    }

    /*callBack(beginDate,endDate){
        if(beginDate){
            beginDate = dayjs(beginDate, "YYYY/MM/DD").format('x');
            beginDate = parseInt(beginDate);
        }
        if(endDate){
            endDate = dayjs(endDate, "YYYY/MM/DD").format('x');
            endDate = parseInt(endDate);
            endDate = endDate + 86399000;
        }
        console.log(beginDate,"beginDate");
        console.log(endDate,"endDate");
        this.props.callBack(beginDate,endDate);
    }*/

    getMenu = () => {
        return (
            <Menu onClick={this.handleTime.bind(this)} items={this.list}>
                {/*{this.list.map(function (item) {*/}
                    {/*return <Menu.Item key={item.key}>{item.name}</Menu.Item>;*/}
                {/*})}*/}
            </Menu>
        );
    };

    render() {
        let _this = this;
        this.params.name = __getServerLanguage("JinNTian", this.props.days);
        return (
            <Dropdown trigger={["click"]} dropdownRender={(menu) =>this.getMenu()}>
                <a
                    className="ant-dropdown-link"
                    onClick={(e) => e.preventDefault()}
                >
                    {_this.params.name} <DownOutlined />
                </a>
            </Dropdown>
        );
    }
}

TimeSelect.defaultProps = {
    days: null,
    callBack: function () {},
};

TimeSelect.propTypes = {};
export default TimeSelect;
